import { t } from '@/i18n';

import getExtraUrl from './extraUrl';

export const normalizeMenus = (projects: Project.TProjectList = []) => {
  const locale = localStorage.getItem('locale') || 'en-US';

  const flatMenus: Project.ISubProject[] = [];
  projects.forEach((item) => {
    item.data.forEach((subItem: Project.ISubProject) => {
      subItem.key = subItem.projectTag;
      subItem.title = subItem.projectName;
      const extraUrl = getExtraUrl(`/main-${subItem.projectTag}`);
      if (extraUrl) {
        subItem.is_blank = '_blank';
        subItem.path = extraUrl;
      } else {
        subItem.path = `/main-${subItem.projectTag}`;
      }
      // 中文直接用projectName，其它语言走本地国际化
      subItem.projectName =
        locale === 'zh-CN' ? subItem.projectName : t(`apps.${subItem.projectTag}`);
      flatMenus.push(subItem);
    });
  });
  return flatMenus;
};

export function isSubPath(parentPath: string, childPath: string) {
  const normalizedParentPath = parentPath.endsWith('/') ? parentPath : `${parentPath}/`;
  const normalizedChildPath = childPath.endsWith('/') ? childPath : `${childPath}/`;

  return normalizedChildPath.startsWith(normalizedParentPath);
}

export function getFirstLevelRoute(path: string): string {
  if (!path || path === '/') return '';

  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  const firstSlashIndex = normalizedPath.indexOf('/');

  const firstLevelRoute =
    firstSlashIndex === -1 ? normalizedPath : normalizedPath.slice(0, firstSlashIndex);

  return firstLevelRoute.replace('main-', '');
}
